import React from 'react';
import Redirect from '../components/Redirect';

const IndexPage = () => {
  return <Redirect to="/r2d2" includeQuery />;
};

export default IndexPage;
